import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { StorageService } from 'app/services/storage.service';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Tag } from 'app/models/tag';
import { TagService } from 'app/services/tag.service';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-add-webdav-storage',
  templateUrl: './add-webdav-storage.component.html',
  styleUrls: ['./add-webdav-storage.component.scss']
})
export class AddWebDavStorageComponent implements OnInit {

  webdavForm: FormGroup;
  storageId: number;
  loading: boolean = false;

  isNgSelectLoading: boolean = false;

  constructor(private validationHandler: ValidationHandler,
    public storageService: StorageService, private formBuilder: FormBuilder, private navigateRoute: Router,
    private toastService: ToastService, private _route: ActivatedRoute,
    public tagService: TagService, private ecoDocsTitleService: EcoDocsTitleService) {

    //Validate From for Submition 
    this.webdavForm = this.storageService.getWebDAVFormGroup();
    
    //Get FTP driver for edit 
    this._route.params.subscribe(params => {
      if (params.storageid) {
        this.storageId = +params.storageid;
        this.loading = true;
        storageService.getById(this.storageId).pipe(finalize(() => {
          this.loading = false;
        })).subscribe(f => {
          this.webdavForm.patchValue(f);
        });
      }
    });
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Add WebDAV Storage' , false);
  }

  onAddTag (name: string) {
    this.isNgSelectLoading = true;
    return this.tagService.add(name).pipe(finalize(()=>{
      this.isNgSelectLoading = false;
    })).toPromise();
  }
  
  showPassword(input) {
    if (input.type == "text") {
      input.type = "password"
    }
    else {
      input.type = "text"
    }
  }
  submit(frm: FormGroup) {
    this.loading = true;
    if (!frm.valid) {
      this.validationHandler.onSubmitCheck(frm);
      this.loading = false;
      return;
    }
    if (this.storageId) {
      this.storageService.updateWebdav(frm.value).subscribe(t => {
        this.loading = false;
        this.navigateRoute.navigateByUrl('/manage/storage')

      }, err => {
        this.loading = false;
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, frm);
        }
        else
          this.toastService.error("Save Failed");
      });
    }
    else {
      this.storageService.addWebdav(frm.value).subscribe(t => {
        this.loading = false;
        this.navigateRoute.navigateByUrl('/manage/storage')

      }, err => {
        this.loading = false;
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, frm);
        }
        else
          this.toastService.error("Save Failed");
      });
    }
  }

  testConnection(frm: FormGroup) {
    if (!frm.valid) {
      this.validationHandler.onSubmitCheck(frm);
      return;
    }

    this.loading = true;
    this.storageService.webdavtestConnection(frm.value).pipe(finalize(() => {
      this.loading = false;
    })).subscribe(t => {
      this.toastService.success("Connection Succeeded!");
    }, err => {
      if (err.status === 422) {
        this.validationHandler.serverValidationHandler(err, this.webdavForm);
      }
      else {
        this.webdavForm.get('password').setErrors({ error: 'Connection Failed' });
      }
    });
  }

}